import template from './acris-faq-index.html.twig';

const { Mixin } = Shopware;
const { Component } = Shopware;

Component.register('acris-faq-index', {
    template,

    mixins: [
        Mixin.getByName('listing'),
        Mixin.getByName('notification'),
        Mixin.getByName('placeholder')
    ],

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    }
});
